enum RemarksTypesEnum {
  ULRemarks = 1,
  CustomerRemarks = 2,
  TaskComment = 3,
}

export default RemarksTypesEnum
